export default function getOption(option: string) {
  option = option.toUpperCase();
  let value = '' as string | undefined | Array<string>;

  switch (option) {
    case 'TITLE':
      value = process.env.NEXT_PUBLIC_TITLE;
      break;
    case 'API_URL':
      value = process.env.NEXT_PUBLIC_API_URL;
      break;
    case 'SHOW_USER_FUNCTIONS':
      value = process.env.NEXT_PUBLIC_SHOW_USER_FUNCTIONS;
      break;
    case 'SHOW_AUCTIONS':
      value = process.env.NEXT_PUBLIC_SHOW_AUCTIONS;
      break;
    case 'HAS_AUCTIONS':
      value = process.env.NEXT_PUBLIC_HAS_AUCTIONS;
      break;
    case 'HAS_FIXED_PRICE':
      value = process.env.NEXT_PUBLIC_HAS_FIXED_PRICE;
      break;
    case 'LOGO':
      value = process.env.NEXT_PUBLIC_LOGO;
      break;
    case 'VAT_PERCENTAGE':
      value = process.env.NEXT_PUBLIC_VAT_PERCENTAGE;
      break;
    case 'SHIPPING_CALCULATOR':
      value = process.env.NEXT_PUBLIC_SHIPPING_CALCULATOR;
      break;
    case 'FINANCIAL_CALCULATOR':
      value = process.env.NEXT_PUBLIC_FINANCIAL_CALCULATOR;
      break;
    case 'DEFAULT_LOCALE':
      value = process.env.NEXT_PUBLIC_DEFAULT_LOCALE;
      break;
    case 'SIBLING_SITE_URL':
      value = process.env.NEXT_PUBLIC_SIBLING_SITE_URL;
      break;
    case 'ADMIN_URL':
      value = process.env.NEXT_PUBLIC_ADMIN_URL;
      break;
    case 'URL':
      value = process.env.NEXT_PUBLIC_URL;
      break;
    case 'WEIGHT_CATEGORIES':
      value = process.env.NEXT_PUBLIC_WEIGHT_CATEGORIES;
      break;
    case 'COLLECT_BANKACCOUNT_INFO':
      value = process.env.NEXT_PUBLIC_COLLECT_BANKACCOUNT_INFO;
      break;
    case 'CATEGORY_TO_IGNORE_CHASSIS':
      value = process.env.NEXT_PUBLIC_CATEGORY_TO_IGNORE_CHASSIS;
      if (value) {
        value = value.split(',');
      } else {
        value = [];
      }
      break;
    //case '':
    //  value = process.env.NEXT_PUBLIC_;
    //  break;
    default:
      break;
  }

  if (typeof value === 'undefined') {
    return undefined;
  }
  if (typeof value !== 'string') {
    return value;
  }
  if (value.toLowerCase() === 'true') {
    return true;
  }
  if (value.toLowerCase() === 'false') {
    return false;
  }
  return value;
}
